<template>
  <div class="auth-wrapper">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'auth'
}
</script>